import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import Tracking from './Tracking';
import Forms from './Forms';
import Installation from './Installation';
import Integrations from './Integrations';
import Email from './Email';
import Fragment from './Fragment';
export default _objectSpread({}, Tracking, Email, Forms, Integrations, Installation, {
  Fragment: Fragment
});